import React from "react";
import { Modal, Box } from "@mui/material";
import {
  makeStyles,
  Typography,DialogContent,Dialog,useMediaQuery
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { current } from "immer";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import config from "../../../config/aws-exports";
import { useTheme } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import { authData } from "../../../redux/auth/authSlice";
import Downloadcsv from "./Downloadcsv";
// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "inline-block",
//     width: "100%",
//     paddingTop: "20px",
//   },
//   root1: {
//     width: "100%",
//   },
//   programtitle: {
//     fontSize: "18px",
//     color: config.main_color_1,
//   },
//   heading: {
//     fontSize: "18px",
//     fontWeight: 400,
//     color: config.main_color_1,
//   },
//   coursetitle: {
//     fontSize: "16px",
//     fontWeight: 400,
//     color: config.main_color_2,
//   },
//   modulename: {
//     fontSize: "14px",
//     fontWeight: 400,
//     color: "black",
//     width: "60%",
//   },
//   subheading: {
//     color: "black",
//     fontFamily: "nunito",
//     fontSize: "14px",
//     fontWeight: "600px",
//   },
//   "MuiAccordionDetails-root": {
//     display: "inline-block",
//     width: "100%",
//     padding: "10px 20px",
//   },
// }));
export default function AssignAndAssessPopUp(props) {
  //const classes = useStyles();
  const theme = useTheme();
  let userDetails = useSelector(authData);
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleClose = () => {
    props.setAssignOpen(false);
  };
  let arrHeader = ["title", "score"];
  let newHeaders = ["title", "Score"];
  console.log("props", props.modalOpen.type);
  return (
    <>
    
      {props.assignOpen && (
           <Dialog
          fullScreen={fullScreen}
          open={props.assignOpen}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent>
            <div>
            <div style={{display:"flex",justifyContent:"end",margin:"-5px -20px 10px 0px"}}>
              <button
                onClick={handleClose}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  float:'right'
                }}
              >
                <CloseIcon fontSize="large" />
              </button>
              </div>
              <div style={{display:'flex'}}>
             <h3 style={{width:'375px',paddingBottom:'10px'}}>{props.modalOpen.type == "assign" ? "Assignment Score" : "Assessment Score"} - {props.uname}</h3>
                <Downloadcsv maindata={props.assignAndAssessData} arrHeader={arrHeader} 
          newHeaders={newHeaders} filename={props.modalOpen.type} />  
             </div>
              <div className="leftaccordionholder">
                
                <table>
                  <tr>
                    <th
                      style={{
                        minWidth: "250px",
                        backgroundColor: "#0f80a4",
                        color: "#fff",
                        fontSize: "16px",
                        padding: "1rem",
                      }}
                    ></th>
                    <th
                      style={{
                        minWidth: "150px",
                        backgroundColor: "#0f80a4",
                        color: "#fff",
                        fontSize: "16px",
                        padding: "1rem",
                        display: "grid",
                        placeItems: "center",
                      }}
                    >
                      Score
                    </th>
                  </tr>
                      {props.assignAndAssessData !== undefined && 
                      props.assignAndAssessData.map((aascore, i) => {
                        return (
                          <>
                            {aascore.score !== undefined && (
                              <>
                                {aascore.score !== -1 && (

                                  <tr style={{ borderBottom: "1px solid #fff" }} >
                                    <td
                                      style={{
                                        minWidth: "250px",
                                        backgroundColor: "#0f80a4",
                                        color: "#fff",
                                        fontSize: "16px",
                                        padding: "1rem",
                                      }}
                                    >
                                      {aascore.title}
                                    </td>

                                    <td
                                      style={{
                                        fontSize: "16px",
                                        padding: "1rem",
                                        display: "grid",
                                        placeItems: "center",
                                      }}
                                    >
                                      {aascore.score} 
                                    </td>
                                  </tr>
                                )}
                              </>
                            )}
                          </>
                        );
                      })}
                  
                </table>
              </div>
            </div>
          </DialogContent>
        </Dialog>
       
    
      )}
    </>
  );
}

